// extracted by mini-css-extract-plugin
export default {"Gallery":"gallerySection_Gallery__B6xSL"};